import { useSelector, useDispatch } from "react-redux";
import DiscardDialog from "cxfcomponents/DiscardDialog";
import { closeDiscardDialog } from "redux/actions/flowDesigner/commonActionCreator";

const DiscardChangesDialog = ({ onAccept, isParentDialogVisible = true }) => {
  const { showDiscardDialog } = useSelector((store) => store?.designer?.common);
  const dispatch = useDispatch();

  const handleDiscardDialogClose = () => {
    dispatch(closeDiscardDialog());
  };

  return (
    <DiscardDialog
      open={isParentDialogVisible ? showDiscardDialog : false}
      handleDialogClose={handleDiscardDialogClose}
      onAccept={onAccept}
    />
  );
};

export default DiscardChangesDialog;
